import {
  ForgotPasswordFormData,
  LoginFormData,
  LoginResponse,
  RegisterFormData,
  ResetPasswordFormData
} from '@greet/shared';
import { useMutation } from '@tanstack/react-query';
import { useAuth } from '../contexts/AuthContextNext';
import { api } from '../utils/api';

export function useLogin() {
  return useMutation({
    mutationFn: async (data: LoginFormData) => {
      const { data: responseData } = await api.post<LoginResponse>('/auth/login', data);
      return responseData;
    },
  });
}

export function useRegister() {
  const { login } = useAuth();
  
  return useMutation({
    mutationFn: async (data: RegisterFormData) => {
      const { data: responseData } = await api.post<LoginResponse>('/auth/register', {
        email: data.email,
        password: data.password,
        businessName: data.businessName,
        website: data.website,
        phoneNumber: data.phoneNumber,
      });
      return responseData;
    },
    onSuccess: (data) => {
      // Automatically log the user in after successful registration
      login(data.token, {
        id: data.user.id,
        email: data.user.email,
        isAdmin: data.user.isAdmin,
        businessId: data.user.businessId || '',
        businessName: data.user.businessName || '',
      });
    },
  });
}

export function useForgotPassword() {
  return useMutation({
    mutationFn: async (data: ForgotPasswordFormData) => {
      const { data: responseData } = await api.post('/auth/forgot-password', data);
      return responseData;
    },
  });
}

export function useResetPassword() {
  return useMutation({
    mutationFn: async (data: ResetPasswordFormData) => {
      const { data: responseData } = await api.post('/auth/reset-password', data);
      return responseData;
    },
  });
} 